import { address as mainAddress, abi as mainAbi } from '../contract/dev/main'
import { address as customAddress, abi as customAbi } from '../contract/dev/custom'
import { address as miningAddress, abi as miningAbi, abiMap } from '../contract/dev/mining'
import { address as mappingAddress, abi as mappingAbi } from '../contract/dev/mapping'
import { network } from '../network/dev'
export default {
  env: 'dev',
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://niu-market.com',
  gameApiBaseUrl: 'http://172.22.142.71:19999', // 游戏API的baseUrl (带端口)
  isEnableEncryption: false, //是否加密
  isLog: true, //是否打印日志
  isEnableConsole: true, //是否允许console.log输出
  isVerifyToken: import.meta.env.VITE_VERIFY_TOKEN === 'true', // 本地默认不走登录签名；需要恢复时配置 VITE_VERIFY_TOKEN=true
  debugCode: 'abcdef', //调试的时候邀请码
  suffix: 'ae298c2a6477a1f6c9a83e601f1b5828', //后端统一拦截路由
  // 主合约 一般是测试网或者主网的usdt合约
  main: {
    address: mainAddress,
    abi: mainAbi
  },
  // 自定义合约 一般是自己写的合约
  custom: {
    address: customAddress,
    abi: customAbi
  },
  // 挖矿合约
  mining: {
    address: miningAddress,
    abi: miningAbi,
    abiMap
  },
  // 兑换配置 - BNB转账
  exchange: {
    bnbAddress: '0x52C9Fb84932CF18e1906659B75c9280591a995E9',
    bnbAmount: '0.00035' // BNB数量
  },
  // 映射合约
  mapping: {
    address: mappingAddress,
    abi: mappingAbi
  },
  depositContract: import.meta.env.VITE_DEPOSIT_CONTRACT || '',
  // LON合约地址
  lonContract: {
    address: '0x9c8b16c5a22238161014ae0776630f728b651017',
    decimal: 18
  },
  network
}
